import { NectaryElement, updateAttribute } from '../utils';
const iconStylesHtml = '<style>:host{display:inline-block;vertical-align:middle}svg{display:block;pointer-events:none;fill:var(--sinch-global-color-icon,var(--sinch-sys-color-text-default));height:var(--sinch-global-size-icon,24px)}</style>';
export const createIconClass = templateHTML => {
  const template = document.createElement('template');
  template.innerHTML = iconStylesHtml + templateHTML;
  return class extends NectaryElement {
    constructor() {
      super();
      const shadowRoot = this.attachShadow();
      shadowRoot.appendChild(template.content.cloneNode(true));
      this.$svg = shadowRoot.querySelector('svg');
    }
    connectedCallback() {
      updateAttribute(this.$svg, 'preserveAspectRatio', 'xMinYMin meet');
    }
  };
};